(function() {
  "use strict";
  angular.module("marketPlace.currency", []);
})();
